/* eslint-disable no-param-reassign */
import { PropertyDetailsType } from '__core/shared/model/finance/PropertyDetails.enum';
import template from './thirdPartyIntegrations.template.html';

export default {
  template,
  bindings: {
    account: '<',
    organization: '<',
    showIntegration: '<',
    showDialog: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $q,
      $rootScope,
      $timeout,
      $window,
      $mdMedia,
      $stateParams,
      $location,
      uiService,
      driveService,
      googleContactsService,
      googleTasksService,
      outlookService,
      coreLogicService,
      priceFinderService,
      slackService,
      movingHubService,
      navigationService,
      helperService,
      INSTANCE
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.hasAliEnabled = false;
      ctrl.isLoanQEnabled = false;
      ctrl.hasFlexEnabled = false;
      ctrl.isMovingHubEnabled = false;
      ctrl.hasVeroEnabled = false;
      ctrl.hasSettleEasyEnabled = false;
      ctrl.hasAllianzEnabled = false;
      ctrl.showIllion = false;
      ctrl.showIllionBankStatements = false;
      ctrl.showCashDeck = false;
      ctrl.showEquifax = false;
      ctrl.showFlex = false;
      ctrl.loanqUrl = 'https://www.loanq.com.au';
      ctrl.showLoanq = false;
      ctrl.showMercury = false;
      ctrl.showPepperResolve = false;
      ctrl.showRpData = false;
      ctrl.showAli = false;
      ctrl.showAllianz = false;
      ctrl.showHoney = false;
      ctrl.showVero = false;
      ctrl.showCompareClub = false;
      ctrl.showLid = false;
      ctrl.showMyConnect = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.hasPepperResolveEnabled = $rootScope.hasPepperResolveEnabled();
        ctrl.hasAliEnabled = $rootScope.hasAliEnabled();
        ctrl.hasAllianzEnabled = $rootScope.hasAllianzEnabled();
        ctrl.isMercuryEnabled = $rootScope.hasMercuryEnabled();
        ctrl.isMogoPlusEnabled = $rootScope.hasMogoPlusEnabled();
        ctrl.isCompareClubEnabled = $rootScope.hasCompareClubEnabled();
        ctrl.isLifeInsuranceDirectEnabled = $rootScope.hasLifeInsuranceDirectEnabled();
        ctrl.isLoanQEnabled = $rootScope.hasLoanQEnabled();
        ctrl.hasFlexEnabled = $rootScope.hasFlexEnabled();
        ctrl.isMovingHubEnabled = $rootScope.isMovingHubEnabled();
        ctrl.hasVeroEnabled = $rootScope.hasVeroEnabled();
        ctrl.hasSettleEasyEnabled = $rootScope.hasSettleEasyEnabled();
        ctrl.hasCreditFixSolutionEnabled = $rootScope.hasCreditFixSolutionEnabled();
        ctrl.hasHoneyEnabled = $rootScope.hasHoneyEnabled();
        ctrl.account = ctrl.account || {};
        ctrl.organization = ctrl.organization || {};
        ctrl.showIntegration = ctrl.showIntegration || false;
        ctrl.showDialog = ctrl.showDialog || false;

        $q.when()
          .then(() => {
            if ($stateParams?.type === 'dropbox') {
              return {
                status: $stateParams?.code === 'true',
                provider: 'Dropbox'
              };
            }
            if ($stateParams?.type === 'googleDrive') {
              return {
                status: $stateParams?.code === 'true',
                provider: 'Google Drive'
              };
            }
            if ($stateParams.type === 'googleContacts' && $stateParams.code === 'true') {
              return googleContactsService.authenticated({
                code: $stateParams.code,
                idAccount: $rootScope.CurrentAccount.id,
                type: $stateParams.type
              });
            }
            if ($stateParams.type === 'googleTasks' && $stateParams.code === 'true') {
              return googleTasksService.authenticated({
                code: $stateParams.code,
                idAccount: $rootScope.CurrentAccount.id,
                type: $stateParams.type
              });
            }
            if ($stateParams?.type === 'oneDrive') {
              return {
                status: $stateParams?.code === 'true',
                provider: 'One Drive'
              };
            }
            if ($stateParams.type === 'outlookContacts' && $stateParams.code === 'true') {
              return outlookService.authenticated({
                code: $stateParams.code,
                idAccount: $rootScope.CurrentAccount.id,
                type: $stateParams.type
              });
            }
            if ($stateParams.type === 'outlookMail' && $stateParams.code === 'true') {
              return outlookService.authenticated({
                code: $stateParams.code,
                idAccount: $rootScope.CurrentAccount.id,
                type: $stateParams.type
              });
            }
            if ($stateParams.type === 'outlookTasks' && $stateParams.code === 'true') {
              return outlookService.authenticated({
                code: $stateParams.code,
                idAccount: $rootScope.CurrentAccount.id,
                type: $stateParams.type
              });
            }
            if ($stateParams?.type === 'priceFinder') {
              return {
                status: $stateParams?.code === 'true',
                provider: 'Pricefinder'
              };
            }
            if ($stateParams?.type === 'rpData') {
              return {
                status: $stateParams?.code === 'true',
                provider: 'RP Data'
              };
            }
            if ($stateParams.code && $stateParams.state) {
              return slackService.authenticated({
                code: $stateParams.code,
                state: $stateParams.state
              });
            }
            return null;
          })
          .then((response) => {
            ctrl.isReady = true;
            if (response?.status && response?.provider) {
              navigationService.organizationChange({
                idOrganization: $rootScope.CurrentOrganization.id
              });
              uiService.toast({
                text: {
                  p1: 'Authentication with',
                  p2: response.provider,
                  p3: 'completed successfully'
                },
                success: true
              });
            }
            if (!response?.status && response?.provider) {
              uiService.toast({
                text: {
                  p1: 'Authentication with',
                  p2: response.provider,
                  p3: 'has failed'
                },
                warn: true
              });
            }
            ctrl.loanqAddress();
          });
      };

      // #region Illion
      ctrl.illionAuthentication = () => {
        if (!ctrl.account.isIllionEnabled()) {
          ctrl.showIllion = true;
          uiService.toast({
            text: {
              p1: 'Initializing',
              p2: 'Illion',
              p3: 'authentication'
            },
            progress: true
          });
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Illion',
              p3: 'authentication'
            },
            progress: true
          });
          $timeout(() => {
            ctrl.illionAuthenticationFinished();
          });
        }
      };

      ctrl.illionAuthenticationFinished = (result) => {
        ctrl.showIllion = false;
        ctrl.account.integrations.illion = {
          enabled: false,
          userKey: null,
          password: null,
          subscriberId: null
        };
        if (result) {
          ctrl.account.integrations.illion = {
            enabled: true,
            userKey: result.userKey,
            password: result.password,
            subscriberId: result.subscriberId
          };
        }
        const data = {
          id: ctrl.account.id,
          integrations: {
            illion: ctrl.account?.integrations?.illion || {}
          },
          integration: 'illion'
        };
        ctrl.saveAccount({ data });
      };
      // #endregion Illion

      // #region Bankstatements
      ctrl.illionBankStatementsAuthentication = () => {
        if (!ctrl.account.isBankStatementsEnabled()) {
          ctrl.showIllionBankStatements = true;
          uiService.toast({
            text: {
              p1: 'Initializing',
              p2: 'Bank Statements',
              p3: 'authentication'
            },
            progress: true
          });
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Bank Statements',
              p3: 'authentication'
            },
            progress: true
          });
          $timeout(() => {
            ctrl.illionBankStatementsAuthenticationFinished();
          });
        }
      };

      ctrl.illionBankStatementsAuthenticationFinished = (result) => {
        ctrl.showIllionBankStatements = false;
        ctrl.account.integrations.bankStatements = {
          enabled: false,
          code: null,
          isMultiBankEnabled: false
        };
        if (result && result?.code) {
          ctrl.account.integrations.bankStatements = {
            enabled: true,
            code: result.code,
            isMultiBankEnabled: result?.isMultiBankEnabled || false
          };
        }
        const data = {
          id: ctrl.account.id,
          integrations: {
            bankStatements: ctrl.account?.integrations?.bankStatements || {}
          },
          integration: 'bankStatements'
        };
        ctrl.saveAccount({ data });
      };
      // #endregion Bankstatements

      // #region Cash Deck
      ctrl.cashDeckAuthentication = () => {
        if (!ctrl.account?.integrations?.cashDeck?.enabled) {
          ctrl.showCashDeck = true;
          uiService.toast({
            text: {
              p1: 'Initializing',
              p2: 'Cash Deck',
              p3: 'authentication'
            },
            progress: true
          });
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Cash Deck',
              p3: 'authentication'
            },
            progress: true
          });
          $timeout(() => {
            ctrl.cashDeckAuthenticationFinished();
          });
        }
      };

      ctrl.cashDeckAuthenticationFinished = (result) => {
        ctrl.showCashDeck = false;
        ctrl.account.integrations.cashDeck = { enabled: false, apiKey: null };
        if (result) {
          ctrl.account.integrations.cashDeck = { enabled: true, apiKey: result };
        }
        const data = {
          id: ctrl.account.id,
          integrations: { cashDeck: ctrl.account?.integrations?.cashDeck || {} },
          integration: 'cashDeck'
        };
        ctrl.saveAccount({ data });
      };
      // #endregion Cash Deck

      // #region Dropbox
      ctrl.dropboxAuthentication = () => {
        if (!ctrl.account.isDropboxEnabled()) {
          uiService.toast({
            text: {
              p1: 'Initializing',
              p2: 'Dropbox',
              p3: 'authentication'
            },
            progress: true
          });
          driveService
            .authenticate({
              idAccountToAuthenticate: ctrl.account?.id,
              driveType: 'dropbox'
            })
            .then((response) => {
              if (response?.status) {
                $window.location.href = response.url;
              } else {
                uiService.toast({
                  text: {
                    p1: 'Dropbox',
                    p2: 'is currently',
                    p3: 'unavailable'
                  },
                  warn: true
                });
              }
            });
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Dropbox',
              p3: 'authentication'
            },
            progress: true
          });
          driveService
            .deauthenticate({
              idAccountToDeauthenticate: ctrl.account?.id,
              driveType: 'dropbox'
            })
            .then((response) => {
              if (response?.status) {
                uiService.toast({
                  text: {
                    p1: 'Dropbox',
                    p2: 'authentication',
                    p3: 'revoked'
                  },
                  success: true
                });
                $timeout(() => {
                  ctrl.account.integrations.dropbox.enabled = false;
                  const data = {
                    id: ctrl.account.id,
                    integrations: {
                      dropbox: ctrl.account?.integrations?.dropbox || {}
                    },
                    integration: 'dropbox',
                    noNeedToUpdate: true
                  };
                  ctrl.saveAccount({ data });
                });
              } else {
                ctrl.account.integrations.dropbox.enabled = true;
                uiService.toast({
                  text: {
                    p1: 'Revoking',
                    p2: 'Dropbox',
                    p3: 'authentication failed'
                  },
                  warn: true
                });
              }
            });
        }
      };
      // #endregion Mercury

      // #region Equifax
      ctrl.equifaxAuthentication = () => {
        if (!ctrl.account.isEquifaxEnabled()) {
          ctrl.showEquifax = true;
          uiService.toast({
            text: {
              p1: 'Initializing',
              p2: 'equifax',
              p3: 'authentication'
            },
            progress: true
          });
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'equifax',
              p3: 'authentication'
            },
            progress: true
          });
          $timeout(() => {
            ctrl.equifaxFinished();
          });
        }
      };

      ctrl.equifaxFinished = (result) => {
        ctrl.showEquifax = false;
        ctrl.account.integrations.equifax = {
          enabled: false,
          username: null,
          password: null
        };
        if (result) {
          ctrl.account.integrations.equifax = {
            enabled: true,
            username: result.username,
            password: result.password
          };
        }
        const data = {
          id: ctrl.account.id,
          integrations: { equifax: ctrl.account?.integrations?.equifax || {} },
          integration: 'equifax'
        };
        ctrl.saveAccount({ data });
      };
      // #endregion Equifax

      // #region Flex
      ctrl.flexAuthentication = () => {
        ctrl.showFlex = true;
        if (!ctrl.account.isFlexEnabled()) {
          ctrl.showFlex = true;
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Flex',
              p3: 'authentication'
            },
            progress: true
          });
          $timeout(() => {
            ctrl.flexFinished();
          });
        }
      };

      ctrl.flexFinished = (result) => {
        ctrl.showFlex = false;
        ctrl.account.integrations.flex = {
          enabled: false,
          email: null,
          username: null,
          password: null
        };
        if (result) {
          ctrl.account.integrations.flex = {
            enabled: true,
            email: result.email,
            username: result.username,
            password: result.password
          };
        }
        const data = {
          id: ctrl.account.id,
          integrations: { flex: ctrl.account?.integrations?.flex || {} },
          integration: 'flex'
        };
        ctrl.saveAccount({ data });
      };
      // #endregion Flex

      // #region Google Contacts
      ctrl.googleContactsAuthentication = () => {
        if (!ctrl.account.isGoogleContactsEnabled()) {
          googleContactsService
            .authenticate({
              idAccount: ctrl.account?.id,
              idOrganization: ctrl.organization?.id,
              type: 'googleContacts'
            })
            .then((response) => {
              if (response.status) {
                $window.location.href = response.url;
              } else {
                uiService.toast({
                  text: {
                    p1: 'Google Contacts',
                    p2: 'is currently',
                    p3: 'unavailable'
                  },
                  warn: true
                });
              }
            });
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Google Contacts',
              p3: 'authentication'
            },
            progress: true
          });
          googleContactsService
            .deauthenticate({ idAccount: ctrl.account.id, type: 'googleContacts' })
            .then(() => {
              $timeout(() => {
                ctrl.account.integrations.googleContacts = { enabled: false };
                const data = {
                  id: ctrl.account.id,
                  integrations: {
                    googleContacts: ctrl.account?.integrations?.googleContacts || {}
                  },
                  integration: 'googleContacts'
                };
                ctrl.saveAccount({ data });
              });
            });
        }
      };
      // #endregion Google Contacts

      // #region Google Drive
      ctrl.googleDriveAuthentication = () => {
        if (!ctrl.account.isGoogleDriveEnabled()) {
          driveService
            .authenticate({
              idAccountToAuthenticate: ctrl.account?.id,
              driveType: 'googleDrive'
            })
            .then((response) => {
              if (response?.status) {
                $window.location.href = response.url;
              } else {
                ctrl.account.integrations.googleDrive.enabled = false;
                uiService.toast({
                  text: {
                    p1: 'Google Drive',
                    p2: 'is currently',
                    p3: 'unavailable'
                  },
                  warn: true
                });
              }
            });
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Google Drive',
              p3: 'authentication'
            },
            progress: true
          });
          driveService
            .deauthenticate({
              idAccountToDeauthenticate: ctrl.account?.id,
              driveType: 'googleDrive'
            })
            .then((response) => {
              if (response?.status) {
                uiService.toast({
                  text: {
                    p1: 'Google Drive',
                    p2: 'authentication',
                    p3: 'revoked'
                  },
                  success: true
                });
                $timeout(() => {
                  ctrl.account.integrations.googleDrive.enabled = false;
                  const data = {
                    id: ctrl.account.id,
                    integrations: {
                      googleDrive: ctrl.account?.integrations?.googleDrive || {}
                    },
                    integration: 'googleDrive',
                    noNeedToUpdate: true
                  };
                  ctrl.saveAccount({ data });
                });
              } else {
                ctrl.account.integrations.googleDrive.enabled = true;
                uiService.toast({
                  text: {
                    p1: 'Revoking',
                    p2: 'Google Drive',
                    p3: 'authentication failed'
                  },
                  warn: true
                });
              }
            });
        }
      };
      // #endregion Google Drive

      // #region Google Task
      ctrl.googleTasksAuthentication = () => {
        if (!ctrl.account.isGoogleTasksEnabled()) {
          googleTasksService
            .authenticate({
              idAccount: ctrl.account?.id,
              idOrganization: ctrl.organization?.id,
              type: 'googleTasks'
            })
            .then((response) => {
              if (response.status) {
                $window.location.href = response.url;
              } else {
                uiService.toast({
                  text: {
                    p1: 'Google Tasks',
                    p2: 'is currently',
                    p3: 'unavailable'
                  },
                  warn: true
                });
              }
            });
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Google Tasks',
              p3: 'authentication'
            },
            progress: true
          });
          googleTasksService
            .deauthenticate({ idAccount: ctrl.account.id, type: 'googleTasks' })
            .then(() => {
              $timeout(() => {
                ctrl.account.integrations.googleTasks = { enabled: false };
                const data = {
                  id: ctrl.account.id,
                  integrations: {
                    googleTasks: ctrl.account?.integrations?.googleTasks || {}
                  },
                  integration: 'googleTasks'
                };
                ctrl.saveAccount({ data });
              });
            });
        }
      };
      // #endregion Google Task

      // #region LoanQ
      ctrl.loanqAddress = () => {
        const lq = ctrl.loanqTokens();
        const prefix =
          INSTANCE.prefix.toLowerCase() === 'loanq' ? 'app' : INSTANCE.prefix.toLowerCase();
        ctrl.loanqUrl =
          ctrl.account?.integrations?.loanq?.enabled && lq && lq?.id
            ? `https://${prefix}.loanq.com.au/#/${lq.id}/`
            : 'https://www.loanq.com.au';
      };

      ctrl.loanqTokens = () =>
        _.find(ctrl.account?.integrations?.loanq?.tokens, {
          id: ctrl.organization?.externalReferenceId || ''
        });

      ctrl.loanqActivate = () => {
        if (!ctrl.account.integrations.loanq?.enabled) {
          ctrl.showLoanq = true;
        } else {
          uiService.toast({
            text: {
              p1: 'Removing',
              p2: 'LoanQ',
              p3: 'integration'
            },
            progress: true
          });
          $timeout(() => {
            ctrl.loanqFinished();
          });
        }
      };

      ctrl.loanqEdit = () => {
        ctrl.showLoanq = true;
      };

      ctrl.loanqFinished = (result) => {
        ctrl.showLoanq = false;
        const loanq = {
          enabled: false,
          tokens: []
        };

        const orgToken = {
          id: ctrl.organization.externalReferenceId,
          fl: result && !_.isEmpty(result.tokens) ? result.tokens.split(',') : null
        };

        const hasToken = ctrl.loanqTokens();
        loanq.tokens = hasToken
          ? _.reject(ctrl.account.integrations.loanq.tokens, {
              id: ctrl.organization.externalReferenceId
            })
          : [].concat(ctrl.account.integrations.loanq.tokens || []);

        if (orgToken.fl) {
          loanq.tokens.push(orgToken);
        }
        loanq.enabled = !!(loanq.tokens && loanq.tokens.length);

        if (!loanq.enabled) {
          loanq.tokens = [];
        }

        ctrl.account.integrations.loanq = loanq;
        ctrl.loanqAddress();
        const data = {
          id: ctrl.account.id,
          integrations: { loanq: ctrl.account?.integrations?.loanq || {} },
          integration: 'loanq'
        };
        ctrl.saveAccount({ data });
      };
      // #endregion LoanQ

      // #region Mercury
      ctrl.mercuryAuthentication = () => {
        if (!ctrl.account.isMercuryEnabled()) {
          ctrl.showMercury = true;
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Mercury',
              p3: 'authentication'
            },
            progress: true
          });
          $timeout(() => {
            ctrl.mercuryFinished();
          });
        }
      };

      ctrl.mercuryFinished = (result) => {
        ctrl.showMercury = false;
        ctrl.account.integrations.mercury = {
          enabled: false,
          apiKey: null,
          token: null
        };
        if (result) {
          ctrl.account.integrations.mercury = {
            enabled: true,
            apiKey: result.apiKey,
            token: result.token
          };
        }
        const data = {
          id: ctrl.account.id,
          integrations: { mercury: ctrl.account?.integrations?.mercury || {} },
          integration: 'mercury'
        };
        ctrl.saveAccount({ data });
      };
      // #endregion Mercury

      // #region Mogo
      ctrl.mogoAuthentication = () => {
        if (!ctrl.account?.integrations?.mogo?.enabled) {
          uiService.toast({
            text: {
              p1: 'Initializing',
              p2: 'Mogo',
              p3: 'authentication'
            },
            progress: true
          });
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Mogo',
              p3: 'authentication'
            },
            progress: true
          });
        }
        $timeout(() => {
          ctrl.mogoAuthenticationFinished(ctrl.account.integrations.mogo.enabled);
        });
      };

      ctrl.mogoAuthenticationFinished = (result) => {
        ctrl.account.integrations.mogo = {
          enabled: false
        };
        if (result) {
          ctrl.account.integrations.mogo = {
            enabled: true
          };
        }
        const data = {
          id: ctrl.account.id,
          integrations: { mogo: ctrl.account?.integrations?.mogo || {} },
          integration: 'mogo'
        };
        ctrl.saveAccount({ data });
      };
      // #endregion Mogo

      // #region One Drive
      ctrl.oneDriveAuthentication = () => {
        if (!ctrl.account.isOneDriveEnabled()) {
          driveService
            .authenticate({
              idAccountToAuthenticate: ctrl.account?.id,
              driveType: 'oneDrive'
            })
            .then((response) => {
              if (response?.status) {
                $window.location.href = response.url;
              } else {
                ctrl.account.integrations.oneDrive.enabled = false;
                uiService.toast({
                  text: {
                    p1: 'One Drive',
                    p2: 'is currently',
                    p3: 'unavailable'
                  },
                  warn: true
                });
              }
            });
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'One Drive',
              p3: 'authentication'
            },
            progress: true
          });
          driveService
            .deauthenticate({
              idAccountToDeauthenticate: ctrl.account?.id,
              driveType: 'oneDrive'
            })
            .then((response) => {
              if (response?.status) {
                uiService.toast({
                  text: {
                    p1: 'One Drive',
                    p2: 'authentication',
                    p3: 'revoked'
                  },
                  success: true
                });
                $timeout(() => {
                  ctrl.account.integrations.oneDrive.enabled = false;
                  const data = {
                    id: ctrl.account.id,
                    integrations: {
                      oneDrive: ctrl.account?.integrations?.oneDrive || {}
                    },
                    integration: 'oneDrive',
                    noNeedToUpdate: true
                  };
                  ctrl.saveAccount({ data });
                });
              } else {
                ctrl.account.integrations.oneDrive.enabled = true;
                uiService.toast({
                  text: {
                    p1: 'Revoking',
                    p2: 'One Drive',
                    p3: 'authentication failed'
                  },
                  warn: true
                });
              }
            });
        }
      };
      // #endregion One Drive

      // #region Outlook
      ctrl.outlookAuthentication = () => {
        if (!ctrl.account.isOutlookMailEnabled()) {
          outlookService
            .authenticate({
              idAccount: ctrl.account?.id,
              idOrganization: ctrl.organization?.id,
              type: 'outlookMail'
            })
            .then((response) => {
              if (response.status) {
                $window.location.href = response.url;
              } else {
                uiService.toast({
                  text: {
                    p1: 'Outlook',
                    p2: 'is currently',
                    p3: 'unavailable'
                  },
                  warn: true
                });
              }
            });
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Outlook',
              p3: 'authentication'
            },
            progress: true
          });
          outlookService.deauthenticate({ idAccount: ctrl.account.id }).then(() => {
            $timeout(() => {
              ctrl.account.integrations.outlookMail = { enabled: false };
              const data = {
                id: ctrl.account.id,
                integrations: {
                  outlookMail: ctrl.account?.integrations?.outlookMail || {}
                },
                integration: 'outlookMail'
              };
              ctrl.saveAccount({ data });
            });
          });
        }
      };
      // #endregion Outlook

      // #region Outlook Contacts
      ctrl.outlookContactsAuthentication = () => {
        if (!ctrl.account?.integrations?.outlookContacts?.enabled) {
          outlookService
            .authenticate({
              idAccount: ctrl.account?.id,
              idOrganization: ctrl.organization?.id,
              type: 'outlookContacts'
            })
            .then((response) => {
              if (response.status) {
                $window.location.href = response.url;
              } else {
                uiService.toast({
                  text: {
                    p1: 'Outlook',
                    p2: 'is currently',
                    p3: 'unavailable'
                  },
                  warn: true
                });
              }
            });
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Outlook',
              p3: 'authentication'
            },
            progress: true
          });
          outlookService
            .deauthenticate({
              idAccount: ctrl.account.id,
              type: 'outlookContacts'
            })
            .then(() => {
              $timeout(() => {
                ctrl.account.integrations.outlookContacts = { enabled: false };
                const data = {
                  id: ctrl.account.id,
                  integrations: {
                    outlookContacts: ctrl.account?.integrations?.outlookContacts || {}
                  },
                  integration: 'outlookContacts'
                };
                ctrl.saveAccount({ data });
              });
            });
        }
      };
      // #endregion Outlook Contacts

      // #region Outlook Tasks
      ctrl.outlookTasksAuthentication = () => {
        if (
          !ctrl.account.integrations.outlookTasks ||
          !ctrl.account.integrations.outlookTasks.enabled
        ) {
          outlookService
            .authenticate({
              idAccount: ctrl.account.id,
              idOrganization: ctrl.organization?.id,
              type: 'outlookTasks'
            })
            .then((response) => {
              if (response.status) {
                $window.location.href = response.url;
              } else {
                uiService.toast({
                  text: {
                    p1: 'Outlook',
                    p2: 'is currently',
                    p3: 'unavailable'
                  },
                  warn: true
                });
              }
            });
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Outlook',
              p3: 'authentication'
            },
            progress: true
          });
          outlookService
            .deauthenticate({
              idAccount: ctrl.account.id,
              type: 'outlookContacts'
            })
            .then(() => {
              $timeout(() => {
                ctrl.account.integrations.outlookTasks = { enabled: false };
                const data = {
                  id: ctrl.account.id,
                  integrations: {
                    outlookTasks: ctrl.account?.integrations?.outlookTasks || {}
                  },
                  integration: 'outlookTasks'
                };
                ctrl.saveAccount({ data });
              });
            });
        }
      };
      // #endregion Outlook Tasks

      // #region Pepper Resolve
      ctrl.pepperResolveAuthentication = () => {
        if (!ctrl.account.isPepperResolveEnabled()) {
          ctrl.showPepperResolve = true;
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Pepper Resolve',
              p3: 'authentication'
            },
            progress: true
          });
          $timeout(() => {
            ctrl.pepperResolveFinished();
          });
        }
      };
      ctrl.pepperResolveFinished = (result) => {
        ctrl.showPepperResolve = false;
        ctrl.account.integrations.pepperResolve = {
          enabled: false,
          brokerId: null
        };
        if (result) {
          ctrl.account.integrations.pepperResolve = {
            enabled: true,
            brokerId: result.brokerId
          };
        }
        const data = {
          id: ctrl.account.id,
          integrations: { pepperResolve: ctrl.account?.integrations?.pepperResolve || {} },
          integration: 'pepperResolve'
        };
        ctrl.saveAccount({ data });
      };
      // #endregion Pepper Resolve

      // #region Pricefinder
      ctrl.priceFinderAuthentication = () => {
        if (!ctrl.account.isPriceFinderEnabled()) {
          uiService.toast({
            text: {
              p1: 'Initializing',
              p2: 'Pricefinder',
              p3: 'authentication'
            },
            progress: true
          });
          priceFinderService
            .authenticate({ idAccountToAuthenticate: ctrl.account.id })
            .then((response) => {
              if (response.status) {
                $window.location.href = response.url;
              } else {
                ctrl.account.integrations.priceFinder.enabled = false;
                uiService.toast({
                  text: {
                    p1: 'Pricefinder',
                    p2: 'is currently',
                    p3: 'unavailable'
                  },
                  warn: true
                });
              }
            });
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Pricefinder',
              p3: 'authentication'
            },
            progress: true
          });
          priceFinderService
            .deauthenticate({
              idAccountToDeauthenticate: ctrl.account?.id,
              propertyDetailsType: PropertyDetailsType.pricefinder.name
            })
            .then((response) => {
              if (response?.status) {
                uiService.toast({
                  text: {
                    p1: 'Pricefinder',
                    p2: 'authentication',
                    p3: 'revoked'
                  },
                  success: true
                });
                $timeout(() => {
                  ctrl.account.integrations.priceFinder.enabled = false;
                  const data = {
                    id: ctrl.account.id,
                    integrations: {
                      priceFinder: ctrl.account?.integrations?.priceFinder || {}
                    },
                    integration: 'priceFinder',
                    noNeedToUpdate: true
                  };
                  ctrl.saveAccount({ data });
                });
              } else {
                ctrl.account.integrations.priceFinder.enabled = true;
                uiService.toast({
                  text: {
                    p1: 'Revoking',
                    p2: 'Pricefinder',
                    p3: 'authentication failed'
                  },
                  warn: true
                });
              }
            });
        }
      };
      // #endregion Pricefinder

      // #region RP Data
      ctrl.rpDataAuthentication = () => {
        if (!ctrl.account.isRpDataEnabled()) {
          uiService.toast({
            text: {
              p1: 'Initializing',
              p2: `${ctrl.organizationCountry?.cca2 === 'AU' ? 'RP Data' : 'Property Guru'}`,
              p3: 'authentication'
            },
            progress: true
          });
          coreLogicService
            .rpDataAuthenticate({ idAccountToAuthenticate: ctrl.account.id })
            .then((response) => {
              if (response.status) {
                $window.location.href = response.url;
              } else {
                ctrl.account.integrations.rpData.enabled = false;
                uiService.toast({
                  text: {
                    p1: `${
                      ctrl.organizationCountry?.cca2 === 'AU' ? 'RP Data' : 'Property Guru'
                    }`,
                    p2: 'is currently',
                    p3: 'unavailable'
                  },
                  warn: true
                });
              }
            });
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: `${ctrl.organizationCountry?.cca2 === 'AU' ? 'RP Data' : 'Property Guru'}`,
              p3: 'authentication'
            },
            progress: true
          });
          coreLogicService
            .rpDataDeauthenticate({
              idAccountToDeauthenticate: ctrl.account?.id,
              propertyDetailsType: PropertyDetailsType.rp_data.name
            })
            .then((response) => {
              if (response?.status) {
                uiService.toast({
                  text: {
                    p1: `${
                      ctrl.organizationCountry?.cca2 === 'AU' ? 'RP Data' : 'Property Guru'
                    }`,
                    p2: 'authentication',
                    p3: 'revoked'
                  },
                  success: true
                });
                $timeout(() => {
                  ctrl.account.integrations.rpData.enabled = false;
                  const data = {
                    id: ctrl.account.id,
                    integrations: {
                      rpData: ctrl.account?.integrations?.rpData || {}
                    },
                    integration: 'rpData',
                    noNeedToUpdate: true
                  };
                  ctrl.saveAccount({ data });
                });
              } else {
                ctrl.account.integrations.rpData.enabled = true;
                uiService.toast({
                  text: {
                    p1: 'Revoking',
                    p2: `${
                      ctrl.organizationCountry?.cca2 === 'AU' ? 'RP Data' : 'Property Guru'
                    }`,
                    p3: 'authentication failed'
                  },
                  warn: true
                });
              }
            });
        }
      };
      // #endregion RP Data

      // #region Slack
      ctrl.slackAuthentication = () => {
        if (!ctrl.account.isSlackEnabled()) {
          uiService.toast({
            text: {
              p1: 'Initializing',
              p2: 'Slack',
              p3: 'authentication'
            },
            progress: true
          });
          slackService.authenticate().then((response) => {
            if (response.status) {
              $window.location.href = response.url;
            } else {
              uiService.toast({
                text: {
                  p1: 'Slack',
                  p2: 'is currently',
                  p3: 'unavailable'
                },
                warn: true
              });
            }
          });
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Slack',
              p3: 'authentication'
            },
            progress: true
          });
          slackService.deauthenticate().then(() => {
            $timeout(() => {
              ctrl.account.integrations.slack = { enabled: false, token: null };
              const data = {
                id: ctrl.account.id,
                integrations: { slack: ctrl.account?.integrations?.slack || {} },
                integration: 'slack'
              };
              ctrl.saveAccount({ data });
            });
          });
        }
      };
      // #endregion Slack

      // #region ALI
      ctrl.aliAuthentication = () => {
        ctrl.showAli = true;
        if (!ctrl.account.isAliEnabled()) {
          ctrl.showAli = true;
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Ali',
              p3: 'authentication'
            },
            progress: true
          });
          $timeout(() => {
            ctrl.aliFinished();
          });
        }
      };

      ctrl.aliFinished = (result) => {
        ctrl.showAli = false;
        ctrl.account.integrations.ali = {
          enabled: false,
          brokerId: null,
          brokerEmail: null
        };
        if (result) {
          ctrl.account.integrations.ali = {
            enabled: true,
            brokerId: result.brokerId,
            brokerEmail: result.brokerEmail
          };
        }
        const data = {
          id: ctrl.account.id,
          integrations: { ali: ctrl.account?.integrations?.ali || {} },
          integration: 'ali'
        };
        ctrl.saveAccount({ data });
      };
      // #endregion ALI

      // #region Allianz
      ctrl.allianzEnable = () => {
        if (!ctrl.account?.isAllianzEnabled()) {
          ctrl.account.integrations.allianz.enabled =
            !ctrl.account?.integrations?.allianz?.enabled;
          ctrl.showAllianz = true;
        } else {
          uiService.toast({
            text: {
              p1: 'Disable',
              p2: 'the use of',
              p3: 'Allianz integration'
            },
            progress: true
          });
          $timeout(() => {
            ctrl.allianzFinished({ placingOfficerCode: '' });
          });
        }
      };

      ctrl.allianzFinished = (result) => {
        ctrl.showAllianz = false;
        if (!_.isEmpty(result)) {
          ctrl.account.integrations.allianz = {
            enabled: !!result?.placingOfficerCode,
            placingOfficerCode: result?.placingOfficerCode || ''
          };
          const data = {
            id: ctrl.account.id,
            integrations: { allianz: ctrl.account?.integrations?.allianz || {} },
            integration: 'allianz'
          };
          ctrl.saveAccount({ data });
        }
      };
      // #endregion Allianz

      // #region Compare Club
      ctrl.compareClubAuthentication = () => {
        if (!ctrl.account?.integrations?.compareClub?.enabled) {
          ctrl.showCompareClub = true;
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Compare Club',
              p3: 'authentication'
            },
            progress: true
          });
          $timeout(() => {
            ctrl.compareClubFinished();
          });
        }
      };

      ctrl.compareClubFinished = (result) => {
        ctrl.showCompareClub = false;
        ctrl.account.integrations.compareClub = {
          enabled: false,
          brokerCode: null
        };

        if (result) {
          ctrl.account.integrations.compareClub = {
            enabled: true,
            brokerCode: result.brokerCode
          };
        }
        const data = {
          id: ctrl.account.id,
          integrations: { compareClub: ctrl.account?.integrations?.compareClub || {} },
          integration: 'compareClub'
        };
        ctrl.saveAccount({ data });
      };
      // #endregion Compare Club

      // #region Credit Fix Solution Easy
      ctrl.creditFixSolutionEnable = () => {
        $timeout(() => {
          const data = {
            id: ctrl.account.id,
            integrations: {
              creditFixSolution: ctrl.account?.integrations?.creditFixSolution || {}
            },
            integration: 'creditFixSolution'
          };
          ctrl.saveAccount({ data });
        });
      };
      // #endregion Credit Fix Solution Easy

      // #region Life insurance direct
      ctrl.lidAuthentication = () => {
        if (!ctrl.account?.integrations?.lid?.enabled) {
          ctrl.showLid = true;
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Life Insurance Direct',
              p3: 'authentication'
            },
            progress: true
          });
          $timeout(() => {
            ctrl.lidFinished();
          });
        }
      };

      ctrl.lidFinished = (result) => {
        ctrl.showLid = false;
        ctrl.account.integrations.lid = {
          enabled: false,
          token: null,
          trackingCode: null
        };
        if (result) {
          ctrl.account.integrations.lid = {
            enabled: true,
            token: result.token,
            trackingCode: result.trackingCode
          };
        }
        const data = {
          id: ctrl.account.id,
          integrations: { lid: ctrl.account?.integrations?.lid || {} },
          integration: 'lid'
        };
        ctrl.saveAccount({ data });
      };
      // #endregion Life insurance direct

      // #region Honey
      ctrl.honeyEnable = () => {
        if (!ctrl.account?.isHoneyEnabled()) {
          ctrl.account.integrations.honey.enabled = !ctrl.account?.integrations?.honey?.enabled;
          ctrl.showHoney = true;
        } else {
          uiService.toast({
            text: {
              p1: 'Disable',
              p2: 'the use of',
              p3: 'Honey integration'
            },
            progress: true
          });
          $timeout(() => {
            ctrl.honeyFinished({ brokerId: '' });
          });
        }
      };

      ctrl.honeyFinished = (result) => {
        ctrl.showHoney = false;
        if (!_.isEmpty(result)) {
          ctrl.account.integrations.honey = {
            enabled: !!result?.brokerId,
            brokerId: result?.brokerId || ''
          };
          const data = {
            id: ctrl.account.id,
            integrations: { honey: ctrl.account?.integrations?.honey || {} },
            integration: 'honey'
          };
          ctrl.saveAccount({ data });
        }
      };
      // #endregion Honey

      // #region Movinghub
      ctrl.movingHubActivate = () => {
        const phone = ctrl.account?.user?.phone?.onlyNumbers();
        if (!ctrl.account?.integrations?.movingHub?.enabled) {
          if (phone && phone.length === 10) {
            movingHubService.activate({ idUser: ctrl.account.id }).then((res) => {
              if (res.status) {
                ctrl.account.integrations.movingHub.enabled = true;
                const data = {
                  id: ctrl.account.id,
                  integrations: { movingHub: res.movingHub },
                  integration: 'movingHub'
                };
                ctrl.saveAccount({ data });
              }
            });
          } else {
            uiService.toast({
              text: {
                p1: 'The phone number',
                p2: 'must have',
                p3: 'exactly 10 digits'
              },
              warn: true
            });
            $timeout(() => {
              ctrl.account.integrations.movingHub.enabled = false;
            });
          }
        } else {
          uiService.toast({
            text: {
              p1: 'Movinghub',
              p2: 'has been already',
              p3: 'activated'
            },
            progress: true
          });
        }
      };
      // #endregion Movinghub

      // #region MyConnect
      ctrl.myConnectAuthentication = () => {
        ctrl.showMyConnect = true;
        if (!ctrl.account.isMyConnectEnabled()) {
          ctrl.showMyConnect = true;
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'MyConnect',
              p3: 'authentication'
            },
            progress: true
          });
          $timeout(() => {
            ctrl.myConnectFinished();
          });
        }
      };

      ctrl.myConnectFinished = (result) => {
        ctrl.showMyConnect = false;
        ctrl.account.integrations.myConnect = {
          enabled: false,
          agentId: null,
          managerId: null
        };
        if (result) {
          ctrl.account.integrations.myConnect = {
            enabled: true,
            agentId: result.agentId,
            managerId: result.managerId
          };
        }
        const data = {
          id: ctrl.account.id,
          integrations: { myConnect: ctrl.account?.integrations?.myConnect || {} },
          integration: 'myConnect'
        };
        ctrl.saveAccount({ data });
      };
      // #endregion MyConnect

      // #region Settle Easy
      ctrl.settleEasyEnable = () => {
        $timeout(() => {
          const data = {
            id: ctrl.account.id,
            integrations: { settleEasy: ctrl.account?.integrations?.settleEasy || {} },
            integration: 'settleEasy'
          };
          ctrl.saveAccount({ data });
        });
      };
      // #endregion Settle Easy

      // #region Vero
      ctrl.veroAuthentication = () => {
        if (!ctrl.account?.integrations?.vero?.enabled) {
          ctrl.showVero = true;
        } else {
          uiService.toast({
            text: {
              p1: 'Revoking',
              p2: 'Vero',
              p3: 'authentication'
            },
            progress: true
          });
          $timeout(() => {
            ctrl.veroFinished();
          });
        }
      };

      ctrl.veroFinished = (result) => {
        ctrl.showVero = false;
        ctrl.account.integrations.vero = {
          enabled: false,
          brokerIdNumber: ''
        };

        if (result) {
          ctrl.account.integrations.vero = {
            enabled: true,
            brokerIdNumber: result.brokerIdNumber
          };
        }
        const data = {
          id: ctrl.account.id,
          integrations: { vero: ctrl.account?.integrations?.vero || {} },
          integration: 'vero'
        };
        ctrl.saveAccount({ data });
      };
      // #endregion Vero

      // #region Invitation content
      ctrl.onEditInvitationContentFinished = (result) => {
        if (result.id === 'bankStatements') {
          ctrl.account.integrations[result.id].emailCustomContent = result.content;
          uiService.toast({
            text: {
              p1: 'Saving',
              p2: 'Invitation content',
              p3: 'Please wait...'
            },
            progress: true
          });
          const data = {
            id: ctrl.account.id,
            integrations: {
              [result.id]: {
                emailCustomContent: result.content || ''
              }
            },
            integration: `${result.id}`
          };
          ctrl.saveAccount({ data });
        }
      };
      // #endregion Invitation content

      ctrl.saveAccount = (data) => {
        ctrl.onFinished({ data });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
